import React, {memo, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {SET_WARNING_MODAL} from 'store/discountsV2/action';
import DiscountsView from 'routes/App/discountsV2/DiscountsList/DiscountsView';

const DiscountsContainer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => dispatch(SET_WARNING_MODAL(true));
  }, []);

  return <DiscountsView />;
};

export default memo(DiscountsContainer);
